// ============================================================================
// FINANCE FORMAT HELPERS (D11)
// Shared format utilities extracted from inbox components and the publish
// dashboard to eliminate duplication. Import from here instead of defining
// local copies.
// ============================================================================

export function formatCurrency(amount: number | null, currency: string): string {
  if (amount == null) return '—';
  try {
    return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: currency || 'ZAR' }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

export function formatDate(dateStr: string | null): string {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return dateStr;
  }
}

export function formatDateTime(dateStr: string | null): string {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleString('en-ZA', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch {
    return dateStr;
  }
}

export function formatRelative(iso: string | null): { label: string; ageDays: number | null } {
  if (!iso) return { label: 'Never', ageDays: null };
  const ageMs = Date.now() - new Date(iso).getTime();
  if (ageMs < 0) return { label: 'Just now', ageDays: 0 };
  const ageDays = ageMs / (1000 * 60 * 60 * 24);
  if (ageDays < 1) {
    const hours = Math.floor(ageMs / (1000 * 60 * 60));
    return { label: hours <= 0 ? 'Just now' : `${hours}h ago`, ageDays };
  }
  if (ageDays < 30) return { label: `${Math.floor(ageDays)}d ago`, ageDays };
  if (ageDays < 365) return { label: `${Math.floor(ageDays / 30)}mo ago`, ageDays };
  return { label: `${Math.floor(ageDays / 365)}y ago`, ageDays };
}

export function timeAgo(date: string | undefined | null): string {
  if (!date) return 'Never';
  const diff = Date.now() - new Date(date).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(date).toLocaleDateString();
}
